import { render } from "./BottomNavigation.vue?vue&type=template&id=74eda3a4&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=74eda3a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74eda3a4"]])

export default __exports__